<template>
  <v-dialog
    :value="value"
    @input="(v) => !v && $store.dispatch('modal/CLOSE_MODAL')"
    width="320"
    max-width="320"
    transition="dialog-transition"
  >
    <v-card v-if="value" class="overflow-hidden" color="neutral700">
      <SizeBox height="8" />
      <div class="d-flex justify-end">
        <v-avatar
          size="24"
          @click="$store.dispatch('modal/CLOSE_MODAL')"
          class="cursor-pointer"
        >
          <img :src="require(`@/assets/icons/close.svg`)" />
        </v-avatar>
        <SizeBox width="8" />
      </div>
      <v-card-title class="flex-center pt-1">
        {{ title }}
      </v-card-title>
      <v-card-text class="text-center text-pre-wrap">
        {{ content }}
      </v-card-text>

      <v-card-actions class="flex-center">
        <template v-if="single">
          <v-btn
            width="120"
            @click="doAction"
            :loading="action.loadingState || actionLoading"
            v-bind="{
              outlined: true,
              ...action.bind
            }"
          >
            {{ action.text }}
          </v-btn>
        </template>
        <template v-else>
          <v-btn
            width="120"
            @click="doCancel"
            :loading="cancel.loadingState || cancelLoading"
            :color="cancel.color || 'neutral100'"
            light
            v-bind="{
              depressed: true,
              outlined: true,
              ...cancel.bind
            }"
          >
            {{ cancel.text }}
          </v-btn>
          <SizeBox width="16" />
          <v-btn
            width="120"
            @click="doAction"
            :loading="action.loadingState || actionLoading"
            :color="action.color"
            v-bind="{
              depressed: true,
              ...action.bind
            }"
          >
            {{ action.text }}
          </v-btn>
        </template>
      </v-card-actions>
      <SizeBox height="18" />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      cancelLoading: false,
      actionLoading: false
    };
  },

  computed: {
    ...mapState({
      value: (state) => state.modal.isModalOpen,
      //
      single: (state) => state.modal.single,
      title: (state) => state.modal.title,
      content: (state) => state.modal.content,
      cancel: (state) => state.modal.cancel,
      action: (state) => state.modal.action
    })
  },

  methods: {
    async doCancel() {
      this.cancelLoading = true;
      await this.cancel.callback();
      this.$store.dispatch('modal/CLOSE_MODAL');
      this.cancelLoading = false;
    },
    async doAction() {
      this.actionLoading = true;
      await this.action.callback();
      this.actionLoading = false;
      if (this.single) this.$store.dispatch('modal/CLOSE_MODAL');
    }
  }
};
</script>

<style lang="scss" scoped>
//
</style>